import { Box, Button, Grid, Typography } from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { isEmpty } from 'lodash'
import React from 'react'

const useStyles = makeStyles({
  title: {
    color: 'grey',
  },
})

const DeliveryInstructions = ({ curSavedLocation, toggleDeliveryInstructionsDialog }) => {
  const classes = useStyles()
  const handleClick = () => toggleDeliveryInstructionsDialog()
  const emptyDeliveryInstructions = isEmpty(curSavedLocation?.deliveryInstructions)
  return (
    <Grid component={Box} container paddingTop={2} spacing={2}>
      <Grid item xs={12}>
        <Typography className={classes.title} display="inline" variant="body1">
          Delivery Instructions
        </Typography>
        {!emptyDeliveryInstructions && (
          <Button color="primary" onClick={handleClick} size="small">
            Edit
          </Button>
        )}
      </Grid>
      {emptyDeliveryInstructions ? (
        <Grid item xs={12}>
          <Button color="secondary" onClick={handleClick} size="large">
            + Add delivery instructions
          </Button>
        </Grid>
      ) : (
        <Grid item xs={12}>
          <Typography>{curSavedLocation?.deliveryInstructions}</Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default DeliveryInstructions
